var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWorkLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_19615)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7111 12.2238C20.7075 12.2329 20.7 12.2567 20.7 12.3V16H27.5V12.3C27.5 12.2567 27.4925 12.2329 27.4889 12.2238C27.4869 12.219 27.4854 12.2164 27.4847 12.2153C27.4836 12.2146 27.481 12.2131 27.4762 12.2111C27.4671 12.2075 27.4433 12.2 27.4 12.2H20.8C20.7567 12.2 20.7329 12.2075 20.7238 12.2111C20.719 12.2131 20.7164 12.2146 20.7153 12.2153C20.7146 12.2164 20.7131 12.219 20.7111 12.2238ZM28.6 17.1H29.7V12.3C29.7 10.9925 28.7075 10 27.4 10H20.8C19.4925 10 18.5 10.9925 18.5 12.3V17.1C18.5 17.7075 18.9925 18.2 19.6 18.2H28.6V17.1Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7 18.2C13.3075 18.2 12.2 19.3075 12.2 20.7V33.5C12.2 34.8925 13.3075 36 14.7 36H33.5C34.8925 36 36 34.8925 36 33.5V20.7C36 19.3075 34.8925 18.2 33.5 18.2H14.7ZM10 20.7C10 18.0925 12.0925 16 14.7 16H33.5C36.1075 16 38.2 18.0925 38.2 20.7V33.5C38.2 36.1075 36.1075 38.2 33.5 38.2H14.7C12.0925 38.2 10 36.1075 10 33.5V20.7Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1 25.2H11.1V23H37.1V25.2Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 29.1001V24.1001H25.2V29.1001H23Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_19615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.2,
    height: 28.2,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWorkLight);
export default __webpack_public_path__ + "static/media/icon_work_light.1f35f6de.svg";
export { ForwardRef as ReactComponent };